<template lang="html">
  <div class="bimArticleEdit">
    <bim-text type="h4" class="mb-9">
      {{ title }}
    </bim-text>

    <bim-input
      placeholder="Заголовок"
      class="mb-9"
      v-model.trim="form.title"
      :formModel="_self"
      formKey="form.title"
    />

    <!-- Строка с инпутами -->
    <bim-row class="mb-9">

      <bim-col v-if="(
        showPublishDate ||
        showManufacturer ||
        showAuthor ||
        showCategory ||
        showTag ||
        showPublishStatus
      )">
        <div class="d-flex mb-9 bimArticleEdit__datepicker">
          <div class="w-100" v-if="showPublishDate">
            <FieldDatePicker
              v-model="form.public_date"
              placeholder="Дата публикации"
              :validation="fieldsValidation.public_date"
            />
          </div>
        </div>

        <div class="d-flex mb-9" v-if="showManufacturer">
          <FieldSelect
            id="organization_uuid"
            v-model="form.organization_uuid"
            placeholder="Компания"
            :options="manufacturersList"
            :validation="[]"
            showReset
          />
        </div>

        <div class="d-flex mb-9" v-if="showAuthor">
          <FieldSelect
            v-if="form.organization_uuid"
            id="author_uuid"
            v-model="form.author_uuid"
            placeholder="Автор"
            :options="authorsList"
            :validation="fieldsValidation.author_uuid"
          />
          <FieldInput
            v-else
            id="author_uuid"
            v-model="form.author_uuid"
            placeholder="uuid автора"
            :validation="fieldsValidation.author_uuid"
          />
        </div>

        <div class="d-flex mb-9" v-if="showCategory">
          <FieldSelect
            id="section_type"
            v-model="form.section_type"
            placeholder="Выбор категории"
            :options="categoriesList"
            :validation="fieldsValidation.section_type"
          />
        </div>

        <div class="d-flex mb-9" v-if="showTag">
          <FieldSelect
            id="tags_lang"
            v-model="form.tags_lang"
            placeholder="Тег"
            :options="tagsList"
            :validation="fieldsValidation.tags_lang"
          />
        </div>

        <div class="d-flex" v-if="showPublishStatus">
          <FieldSelect
            id="status_lang"
            v-model="form.status_lang"
            placeholder="Статус публикации"
            :options="statusList"
            :validation="fieldsValidation.status_lang"
          />
        </div>
      </bim-col>

      <bim-col class="d-flex flex-column">
        <div
          class="d-flex flex-grow-1"
          :class="{ 'mb-9': showResult }"
          v-if="showShortDesc"
        >
          <FieldTextarea
            v-model="form.preview_text"
            placeholder="Краткое описание"
            :validation="fieldsValidation.preview_text"
          />
        </div>
        <div class="d-flex flex-grow-1" v-if="showResult">
          <FieldTextarea
            v-model="form.itog"
            placeholder="Итог"
            :validation="fieldsValidation.itog"
          />
        </div>
      </bim-col>
    </bim-row>

    <!-- Строка с кнопками и чек-боксами -->
    <bim-row class="mb-9">
      <bim-col>
        <div class="d-flex flex-column align-start">

          <!-- Логотип компании-->
          <div v-if="showLogoImg">
            <FieldImgUpload
              name="Логотип компании"
              @upload="v => onUploadFile('image_case', v)"
              :imgPath="form.image_casePath"
              id="image_case"
              :validation="fieldsValidation.image_casePath"
            >
              <bimTooltip :value="validated && !form.image_casePath">
                Загрузите логотип компании
              </bimTooltip>
            </FieldImgUpload>
          </div>

          <!-- Превью на карточку -->
          <div class="d-inline">
            <FieldImgUpload
              name="Превью на карточку"
              @upload="v => onUploadFile('index_img', v)"
              :imgPath="form.index_imgPath"
              id="index_img"
              :validation="fieldsValidation.index_imgPath"
            >
              <bimTooltip :value="validated && !form.index_imgPath">
                Загрузите превью
              </bimTooltip>
            </FieldImgUpload>
          </div>

          <!-- Изображение внутри статьи -->
          <div>
            <FieldImgUpload
              name="Изображение внутри статьи"
              @upload="v => onUploadFile('head_img', v)"
              :imgPath="form.head_imgPath"
              id="head_img"
              :validation="fieldsValidation.head_imgPath"
            >
              <bimTooltip :value="validated && !form.head_imgPath">
                Загрузите изображение внутри статьи
              </bimTooltip>
            </FieldImgUpload>
          </div>
        </div>
      </bim-col>

      <bim-col class="d-flex flex-column">
        <FieldCheckbox
          v-if="showCheckboxTop"
          v-model="form.is_top"
          class="mt-6"
          label="Топ статья"
        />
        <FieldCheckbox
          v-if="showCheckboxAdvertising"
          v-model="form.advertising"
          class="mt-6"
          label="Рекламный материал"
        />
        <FieldCheckbox
          v-if="showCheckboxMainPage"
          v-model="form.is_on_main_page"
          class="mt-6"
          label="Отображать на главной"
        />
        <FieldCheckbox
          v-if="showCheckboxReadingRoom"
          v-model="form.is_posted_reading_room"
          class="mt-6"
          label="Отображать в чит. зале"
        />
      </bim-col>
    </bim-row>

    <div class="mb-9">
      <FieldEditorJS
        v-model="form.detail_text"
        formKey="form.detail_text"
        :formModel="_self"
        :validation="fieldsValidation.detail_text"
        :imgUploadURL="imgUploadURL"
        :customComponents="editorJsComponents"
      />
    </div>

    <!-- @slot Для добавления контента в конец ( перед кнопками ) -->
    <slot name="bottom"></slot>
    <!-- Строка с кнопками сохранения -->
    <bim-row>
      <bim-col class="d-flex">

        <!-- @slot Кастомные кнопки -->
        <slot name="buttons">
          <div>
            <bim-button
              @click="clickCancel"
              color="gray"
              label="Отмена"
              class="ml-auto mr-6"
            />
            <bim-button
              @click="clickSave"
              label="Сохранить"
            />
          </div>
        </slot>
      </bim-col>
    </bim-row>
  </div>
</template>

<script>
import { uploadImagePrefix } from '@/config'

import bimCol from '@/components/grid/bimCol/bimCol'
import bimRow from '@/components/grid/bimRow/bimRow'
import bimText from '@/components/text/bimText/bimText'
import bimInput from '@/components/form/bimInput/bimInput'
import bimButton from '@/components/form/bimButton/bimButton'
import bimTooltip from '@/components/ui/bimTooltip/bimTooltip'

import FieldInput from '@/components/core/bimArticleEdit/FieldInput'
import FieldSelect from '@/components/core/bimArticleEdit/FieldSelect'
import FieldEditorJS from '@/components/core/bimArticleEdit/FieldEditorJS'
import FieldTextarea from '@/components/core/bimArticleEdit/FieldTextarea'
import FieldCheckbox from '@/components/core/bimArticleEdit/FieldCheckbox'
import FieldImgUpload from '@/components/core/bimArticleEdit/FieldImgUpload'
import FieldDatePicker from '@/components/core/bimArticleEdit/FieldDatePicker'

async function getFileURL (file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)
    fileReader.onload = event => resolve(event.target.result)
    fileReader.onerror = reject
  })
}

class ImagePrefix {
  constructor (prefix) {
    this.prefix = prefix
  }

  add (path, prefix) {
    const _prefix = prefix || this.prefix
    return _prefix + path
  }

  remove (path, prefix) {
    return path.replace(prefix || this.prefix, '')
  }
}

const imagePrefix = new ImagePrefix(uploadImagePrefix)

export const formTemplate = {
  title: '',

  image_case: '',
  image_casePath: '',

  head_img: '',
  head_imgPath: '',

  index_img: '',
  index_imgPath: '',

  tags_lang: '',
  author_uuid: '',
  section_type: '',
  organization_uuid: '',

  itog: '',
  preview_text: '',
  detail_text: {},

  public_date: '',
  status_lang: 'Draft',

  is_top: false,
  advertising: false,
  is_on_main_page: false,
  is_posted_reading_room: false,
}

export default {
  name: 'bimArticleEdit',
  props: {
    /**
     * Заголовок страницы
     */
    title: String,
    /**
     * URL для загрузки картинок
     */
    imgUploadURL: String,
    /**
     * Список производителей
     */
    manufacturersList: Array,
    /**
     * Список авторов
     */
    authorsList: Array,
    /**
     * Список тегов
     */
    tagsList: Array,
    /**
     * Список категорий
     */
    categoriesList: Array,
    /**
     * Статус публикации
     */
    showPublishStatus: Boolean,
    /**
     * Дата публикации
     */
    showPublishDate: Boolean,
    /**
     * Выбор категории статьи
     */
    showCategory: Boolean,
    /**
     * Загрузка логотипа компании ( для кейсов )
     */
    showLogoImg: Boolean,
    /**
     * Итог ( для кейса )
     */
    showResult: Boolean,
    /**
     * Краткое описание
     */
    showShortDesc: Boolean,
    /**
     * Выбор тега ( для кейса )
     */
    showTag: Boolean,
    /**
     * Выбор производителя ( для админки )
     */
    showManufacturer: Boolean,
    /**
     * Выбор автора ( для админки )
     */
    showAuthor: Boolean,
    /**
     * Чекбокс топ статья
     */
    showCheckboxTop: Boolean,
    /**
     * Чекбокс рекламный материал
     */
    showCheckboxAdvertising: Boolean,
    /**
     * Чекбокс показывать на главной
     */
    showCheckboxMainPage: Boolean,
    /**
     * Чекбокс показывать в чит. зале
     */
    showCheckboxReadingRoom: Boolean,
    /**
     * Префикс для отображения картинок
     */
    imageUrlPrefix: {
      type: String,
      default: '/uploads'
    },
    /**
     * Ограничение длины заголовка статьи
     */
    articleTitleMaxLength: {
      type: [String, Number],
      default: 100
    },
    /**
     * Кастомные тулзы для редактора
     */
    editorJsComponents: Object,
    /**
     * Объект формы со следующими полями:<br /><br /><br />
     *
     * Заголовок статьи<br />
     * <b>title</b>: String <br /><br />
     *
     * Статус публикации<br />
     * <b>status_lang?</b>: String <br /><br />
     *
     * Дата публикации<br />
     * <b>public_date?</b>: String <br /><br />
     *
     * Логотип компании<br />
     * <b>image_case?</b>: String <br /><br />
     *
     * Логотип компании ( путь к картинке )<br />
     * <b>image_casePath?</b>: String <br /><br />
     *
     * Превью статьи<br />
     * <b>index_img</b>: String <br /><br />
     *
     * Превью статьи ( путь к картинке )<br />
     * <b>index_imgPath</b>: String <br /><br />
     *
     * Картинка внутри статьи<br />
     * <b>head_img</b>: String <br /><br />
     *
     * Картинка внутри статьи ( путь к картинке )<br />
     * <b>head_imgPath</b>: String <br /><br />
     *
     * Основной текст<br />
     * <b>detail_text</b>: JSON <br /><br />
     *
     * Краткое описание<br />
     * <b>preview_text?</b>: String <br /><br />
     *
     * Итог ( для кейсов )<br />
     * <b>itog?</b>: String <br /><br />
     *
     * Тег ( для кейсов )<br />
     * <b>tags_lang?</b>: String <br /><br />
     *
     * Категория статьи<br />
     * <b>section_type?</b>: String <br /><br />
     *
     * Автор статьи<br />
     * <b>author_uuid?</b>: String <br /><br /><br />
     *
     * Производитель<br />
     * <b>organization_uuid?</b>: String <br /><br /><br />
     *
     * Топ статья<br />
     * <b>is_top?</b>: Boolean <br /><br />
     *
     * Рекламный материал<br />
     * <b>advertising?</b>: Boolean <br /><br />
     *
     * Показывать на главной<br />
     * <b>is_on_main_page?</b>: Boolean <br /><br />
     *
     * Показывать в читальном зале<br />
     * <b>is_posted_reading_room?</b>: Boolean <br /><br />
     *
     * можно импортировать formTemplate со всеми свойствами:<br /><br />
     * <b>import { formTemplate } from '@bimlib/components/bimArticleEdit'</b>
     *
     * @model
     */
    value: {
      type: Object,
      default: () => formTemplate
    },
  },
  components: {
    bimCol,
    bimRow,
    bimText,
    bimInput,
    bimButton,
    bimTooltip,

    FieldInput,
    FieldSelect,
    FieldEditorJS,
    FieldTextarea,
    FieldCheckbox,
    FieldImgUpload,
    FieldDatePicker,
  },
  data () {
    const form = Object.assign({}, formTemplate)
    return {
      imagePrefix: new ImagePrefix(this.imageUrlPrefix),
      form,
      validated: false,
      statusList: [
        {
          value: 'Published',
          label: 'Опубликовано',
        },
        {
          value: 'Moderate',
          label: 'На модерацию',
        },
        {
          value: 'Draft',
          label: 'В черновик',
        },
        {
          value: 'Rejected',
          label: 'Отклонено',
        },
      ],
    }
  },
  created () {
    Object
      .entries(this.value)
      .forEach(([key, value]) => {
        this.form[key] = value
      })
  },
  watch: {
    value: {
      handler (val) {
        this.form = Object.assign(this.form, val)
      },
      deep: true
    },
    form: {
      handler (val) {
        /**
         * Срабатывает при обновлении формы, для v-model
         * @param { formTemplate } val
         */
        this.$emit('input', val)
      },
      deep: true
    }
  },
  methods: {
    clickSave () {
      const result = this.checkFormValid()
      /**
       * Срабатывает при клике на дефолтную кнопку 'сохранить'
       */
      this.$emit('clickSave', result)
    },
    clickCancel () {
      /**
       * Срабатывает при клике на дефолтную кнопку 'отмена'
       */
      this.$emit('clickCancel')
    },
    async onUploadFile (name, event) {
      const file = event.target.files[0]
      return getFileURL(file)
        .then(fileURL => {
          this.form[name] = file
          this.form[`${name}Path`] = fileURL

          /**
           * Загрузка изображения
           * <br /><br />
           * Возвращает объект со следующими свойствами:
           * @param { String } name название поля ( image_case, index_img, head_img )
           * @param { File } file сам файл
           * @param { String } fileName название файла
           * @param { Event } event
           */
          this.$emit('uploadFile', {
            name,
            file,
            event,
            fileName: file.name,
          })
        })
    },
    checkFormValid () {
      this.validated = true
      /* eslint no-prototype-builtins: "off" */
      let valid = true
      this.$emit('validateFields')

      ;(function validate (el) {
        if (!el) return
        if (el.hasOwnProperty('$children')) {
          el.$children.forEach(validate)
        }
        if (el.hasOwnProperty('$v2')) {
          el.$v2.forceValidateForm()
          if (valid && !el.$v2.validForm) {
            valid = false
          }
        }
      })(this)

      return valid
    },
  },
  computed: {
    fieldsValidation () {
      const editorjsValidation = () => {
        const value = this.form.detail_text
        if (
          !value ||
          !value.blocks ||
          !value.blocks.length
        ) return 'Заполните поле'
      }

      const publicDateValidation = () => {
        if (!this.form.public_date) {
          return 'Выберите дату'
        }
      }

      const invalidImg = value => !(value && value.length) || undefined
      const imgCaseValidation = () => invalidImg(this.form.image_casePath)
      const imgHeadValidation = () => invalidImg(this.form.head_imgPath)
      const imgIndexValidation = () => invalidImg(this.form.index_imgPath)

      /* eslint-disable */
      const form = {
        ...this.formValidation,
        head_imgPath:   [imgHeadValidation],
        index_imgPath:  [imgIndexValidation],
        preview_text:   ['required', 'minLength=10'],
        detail_text:    [editorjsValidation],
      }

      if (this.showPublishStatus) form.status_lang            = ['required']
      if (this.showPublishDate)   form.public_date            = [publicDateValidation]
      if (this.showResult)        form.itog                   = ['required', 'minLength=10']
      if (this.showCategory)      form.section_type           = ['required']
      if (this.showTag)           form.tags_lang              = ['required']
      if (this.showLogoImg)       form.image_casePath         = [imgCaseValidation]
      if (this.showAuthor)        form.author_uuid            = ['required']

      if (
        !this.form.organization_uuid ||
        +this.form.organization_uuid === 0
      ) form.author_uuid   = ['required']
      /* eslint-enable */

      return form
    },
    formValidation () {
      return {
        'form.title': ['required', `maxLength=${this.articleTitleMaxLength}`]
      }
    }
  },
  /**
   * Форматирование формы для отправки на сервер
   * @param {Object} form
   * @param {String} prefix - кастомный префикс для изображений
   */
  formatForm (form, prefix = '') {
    const _prefix = prefix || uploadImagePrefix
    /* eslint-disable */
    const date = form.public_date ? new Date(form.public_date) : new Date()

    const {
      image_case,
      image_casePath,
      index_img,
      index_imgPath,
      head_img,
      head_imgPath,
      detail_text,
      ...other
    } = form

    return {
      ...other,
      public_date: date.toJSON(),
      image_case: image_case || imagePrefix.remove(String(image_casePath), _prefix),
      index_img: index_img || imagePrefix.remove(String(index_imgPath), _prefix),
      head_img: head_img || imagePrefix.remove(String(head_imgPath), _prefix),
      detail_text: JSON.stringify(detail_text),
      language_id: 1,
      service_type: 'bimlib',
      meta_set: []
    }
    /* eslint-enable */
  },
  /**
   * Парсинг формы
   * @param {Object} form
   * @param {String} prefix - кастомный префикс для изображений
   */
  parseForm (form, prefix) {
    const _prefix = prefix || uploadImagePrefix
    /* eslint-disable */
    const {
      public_date,
      image_case,
      index_img,
      head_img,
      detail_text,
      ...other
    } = form

    return {
      ...other,
      public_date: new Date(public_date.replace(' ', 'T')),
      image_casePath: image_case && imagePrefix.add(image_case, _prefix),
      index_imgPath: index_img && imagePrefix.add(index_img, _prefix),
      head_imgPath: head_img && imagePrefix.add(head_img, _prefix),
      detail_text: JSON.parse(detail_text),
    }
    /* eslint-enable */
  },
  formTemplate
}
</script>

<style lang="scss" scoped>
.w-100 {
  width : 100%;
}
.bimArticleEdit {
  .bimArticleEdit__datepicker {
    ::v-deep {
      .mx-datepicker {
        width: 100%;
      }
    }
  }
}
</style>
